import { TitleCasePipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ShoppingRecurrence } from '@infrab4a/connect';
import { TableColumn } from 'src/app/components/table';
import { ShopShoppingRecurrenceService } from 'src/app/connect-api/api/shop/shop-shopping-recurrence.service';
import { getShopsArray, ShopMap } from 'src/app/connect-api/enums/ShopMap';
import {
  getAllRecurrenceStatuses,
  getRecurrenceStatusLabel
} from 'src/app/connect-api/models/ShoppingRecurrenceLabels';

@Component({
  selector: 'app-shop-recurrences',
  templateUrl: './shop-recurrences.component.html',
  styleUrl: './shop-recurrences.component.scss',
  providers: [TitleCasePipe]
})
export class ShopRecurrencesComponent {
  protected recurrenceService = inject(ShopShoppingRecurrenceService);
  private titleCasePipe = inject(TitleCasePipe);

  protected cols = [
    new TableColumn.Builder()
      .setHeader('ID')
      .setField('id')
      .setRouterLink('/shop-orders/recurrence/')
      .setRouterLinkFieldName('id')
      .build(),
    new TableColumn.Builder()
      .setHeader('Loja')
      .setField('shop')
      .setCondition('equals')
      .setDisplayFunction(
        (recurrence: ShoppingRecurrence) =>
          ShopMap[recurrence.shop] ||
          this.titleCasePipe.transform(recurrence.shop)
      )
      .build(),
    new TableColumn.Builder()
      .setHeader('Nome')
      .setField('user.displayName')
      .setCondition('contains')
      .setDisplayFunction(
        (recurrence: ShoppingRecurrence) => recurrence.user?.displayName
      )
      .build(),
    new TableColumn.Builder()
      .setHeader('Email')
      .setField('user.email')
      .setCondition('contains')
      .setDisplayFunction(
        (recurrence: ShoppingRecurrence) => recurrence.user?.email
      )
      .build(),
    new TableColumn.Builder()
      .setHeader('Status')
      .setField('status')
      .setCondition('equals')
      .setDisplayFunction((recurrence: ShoppingRecurrence) =>
        getRecurrenceStatusLabel(recurrence.status)
      )
      .build(),
    new TableColumn.Builder()
      .setHeader('Ativo')
      .setField('active')
      .setType('boolean')
      .setCondition('equals')
      .build()
  ];

  protected dropdownFilters = {
    shop: [{ label: 'Todas', value: undefined }, ...getShopsArray()],
    status: [
      { label: 'Todos', value: undefined },
      ...getAllRecurrenceStatuses()
    ],
    active: [
      { label: 'Todos', value: undefined },
      { label: 'Ativo', value: true },
      { label: 'Inativo', value: false }
    ]
  };

  constructor(title: Title) {
    title.setTitle('Recorrências - Loja');
  }
}
